import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { PROFILES_API, MESSAGES_API } from "../api";
import { setUserCurrentState, setDashboardMessages, setUserIsNewUser } from "../slice";

export const useCurrentState = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { mutateAsync: getMyDashboardMessages } = useMutation(
    () => MESSAGES_API.GetMyDashboardMessages(),
    {
      onSuccess: ({ data }) => {
        if (data.success) {
          dispatch(setDashboardMessages(data.data));
        }
      },
    }
  );

  const { mutateAsync: getMyCurrentState } = useMutation(PROFILES_API.GetMyCurrentState, {
    onSuccess: async ({ data }) => {
      if (data.success) {
        if (window.sessionStorage.getItem("user_current_state") === "45" && data.data.code !== 45) {
          await dispatch(setUserIsNewUser(false));
          await navigate("/personal-info/base-info");
        }
        await dispatch(setUserCurrentState(data.data));
        window.sessionStorage.setItem("user_current_state", data.data.code);
      }
    },
  });

  const updateUserStatus = useCallback(async () => {
    await getMyCurrentState();
    await getMyDashboardMessages();
  }, [getMyCurrentState, getMyDashboardMessages]);

  return updateUserStatus;
};
